import { SecondaryCriteria } from "@planzone/dto";

function hasChanged(criteria: SecondaryCriteria, formData: SecondaryCriteria) {
  const readSet = new Set([
    ...formData.accessRoles.read,
    ...criteria.accessRoles.read,
  ]);
  const writeSet = new Set([
    ...formData.accessRoles.write,
    ...criteria.accessRoles.write,
  ]);

  return (
    criteria.name !== formData.name ||
    criteria.labels.fr !== formData.labels.fr ||
    criteria.labels.en !== formData.labels.en ||
    readSet.size !== criteria.accessRoles.read.length ||
    formData.accessRoles.read.length !== criteria.accessRoles.read.length ||
    writeSet.size !== criteria.accessRoles.write.length ||
    formData.accessRoles.write.length !== criteria.accessRoles.write.length ||
    !![...Object.keys(criteria.attr), ...Object.keys(formData.attr)].find(
      (key) => criteria.attr[key] !== formData.attr[key],
    )
  );
}

export { hasChanged };
